import { defineAction } from "redux-define";
import {
    ERROR,
    FILTER,
    LOADING,
    SUCCESS,
    TheApp
} from "../../constants/stateConstants";


export const facilityLocation = defineAction("facilityLocation", [LOADING, ERROR, SUCCESS], TheApp);
export const LIST = defineAction("LIST", [LOADING, ERROR, SUCCESS, FILTER], facilityLocation);
export const CREATE = defineAction("CREATE", [LOADING, ERROR, SUCCESS], facilityLocation);
export const GET = defineAction("GET", [LOADING, ERROR, SUCCESS], facilityLocation);
// Note: PATCH actions are no longer used - replaced by TanStack Query mutations
// Note: GET_LAYERS, GET_CHECKS, GET_REGISTER_DATA, GET_TODAY_REGISTER_DATA actions
// are no longer used in the ripening room - replaced by TanStack Query hooks
export const GET_LAYERS = defineAction("GET_LAYERS", [LOADING, ERROR, SUCCESS], facilityLocation);
export const GET_CHECKS = defineAction("GET_CHECKS", [LOADING, ERROR, SUCCESS], facilityLocation);
export const GET_REGISTER_DATA = defineAction("GET_REGISTER_DATA", [LOADING, ERROR, SUCCESS], facilityLocation);
export const GET_TODAY_REGISTER_DATA = defineAction("GET_TODAY_REGISTER_DATA", [LOADING, ERROR, SUCCESS], facilityLocation);

